var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"length":_vm.total,"total-visible":7,"color":"primary","circle":""},on:{"input":_vm.update,"next":_vm.update,"previous":_vm.update},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})}
var staticRenderFns = []

export { render, staticRenderFns }